import { useEffect } from 'react';
function isSameOrigin(targetWindow) {
  var currentWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var isSameOrigin;
  try {
    isSameOrigin = (targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.location.origin) === (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.location.origin);
  } catch (e) {
    // catch the DOM exception, mark the resolution to "false"
    isSameOrigin = false;
  }
  return isSameOrigin;
}
export var calculateDepth = function calculateDepth(hostWindow) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentWindow = hostWindow;
  var hostFrameOffset = 0;
  while (currentWindow !== window.top) {
    hostFrameOffset += 1;
    currentWindow = currentWindow.parent;
  }
  return hostFrameOffset - offset;
};
var attachHostOffsetOverride = function attachHostOffsetOverride(window) {
  if (window.top) {
    if (isSameOrigin(window.top)) {
      var containerDepth = calculateDepth(window);
      // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
      window.top.getHostOffsetFunctionOverride = function (hostWindow) {
        return calculateDepth(hostWindow, containerDepth + 1);
      };
    }
  }
};
var detachHostOffsetOverride = function detachHostOffsetOverride() {
  if (window.top) {
    if (isSameOrigin(window.top)) {
      // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
      delete window.top.getHostOffsetFunctionOverride;
    }
  }
};
export function useHostOffsetOverride() {
  useEffect(function () {
    attachHostOffsetOverride(window);
    return function () {
      detachHostOffsetOverride();
    };
  }, []);
}